<template>
  <div class="height-set-for-component">
     <div class="d-flex" style="height:70px">
        <div class="search-bar-comm-style pt-2 col-md-8" style="display: inline-flex;">
            <Multiselect
              v-model="searchKey"
              :options="userListFromAutocomplete"
              :custom-label="selectionLabelCallback"
              track-by="_id"
              :placeholder="$t('Search User')"
              :hideSelected="false"
              :close-on-select="true"
              :limit="1"
              deselectLabel=""
              selectLabel=""
              selectedLabel=""
              :resetAfter="false"
              :showNoOptions="false"
              @search-change="getusersOnKeyup($event)"
              @select="optionsOnSelectCallback($event)"
              @remove="optionsOnRemoveCallback()">
              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
              <div v-if="Object.keys(scope.option).includes('profile_image') && !['undefined',null].includes(scope.option.profile_image) && scope.option.profile_image" class='user-name-or-image'>
                    <img :src="getProxyConvertedImage(scope.option.profile_image)" @error="replaceWithUserIcon($event,scope.option.username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
              </div>
              <div v-else class="user-name-or-image" :style="style(scope.option.username)">{{ scope.option.username.split("")[0] }}</div>
              <span style="margin-inline-start:12px;">{{ scope.option.username }}</span>
              </div>
              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option">
              <span style="margin-inline-start:12px;">ALL</span>
              </div>
              <span slot="noResult">No results.</span>
            </Multiselect>
            <Multiselect
              :custom-label="userStatusLabelCallback"
              v-model="searchStatus"
              :options="fieldTypes"
              :searchable="false"
              :close-on-select="true"
              :allow-empty="false"
              @select="filterUserOnStatus($event)"
              label="label"
              deselectLabel=""
              selectLabel=""
              selectedLabel=""
              :placeholder="$t('Filter based on status')"
              style="margin-inline-start:12px;"
              track-by="type">
              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
              <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
              </div>
              <span slot="noResult">No results.</span>
            </Multiselect>
            <Multiselect
              :custom-label="userTypeLabelCallback"
              v-model="searchUserType"
              :options="userTypes"
              :searchable="false"
              :close-on-select="true"
              :allow-empty="false"
              @select="filterUserType($event)"
              deselectLabel=""
              selectLabel=""
              selectedLabel=""
              :placeholder="$t('Filter based on user type')"
              style="margin-inline-start:12px;"
              track-by="type">
              <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
              <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
              </div>
              <span slot="noResult">No results.</span>
            </Multiselect>
        </div>
        <div class="primary-btn-style justify-content-end pt-2 col-md-4 mr-3">
            <!-- <button class="btn btn-outline-danger mr-2" style="border: 1px solid #831515;" v-on:click="deleteUserBtn()">Delete</button> -->
            <!-- <button class="btn btn-outline-secondary m-2" style="border: 1px solid #585858;" v-on:click="editUser('users-info')">Edit</button> -->
            <button class="btn btn-outline-primary m-2"  v-on:click="changeComponent('add-user')">{{$t('Add')}}</button>
        </div>
        </div>
    <div class="pl-4 pt-0 pr-4 pb-2" style="overflow:auto;height:calc(100% - 70px)">
      <table class="tabletable-with-border table-scroll small-first-col table-cell-styles" style="background: transparent;width:98%;margin:0px 10px !important;">
     <!-- <table
        class="table-with-border table-scroll small-first-col"
        style="background: transparent"
      > -->
        <thead style="color: #eee;height: 40px;">
          <tr>
            <th style="width: 30%" class="text-left">{{$t('Username')}}</th>
            <th style="width: 10%" class="text-left">{{$t('User Type')}} </th>
            <th style="width: 25%;" >{{$t('User Group')}}</th>
            <th style="width: 15%">{{$t('Last Login')}} </th>
            <th style="width: 20%;" class="text-left">{{$t('Email')}}</th>
            <!-- <th style="width: 10%"></th> -->
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in usersListFromServer"
            :key="user._id"
            :id="user._id"
            class="comm-user-row show-delete-icon"
            
            @click="selectRow(user), changeComponent('users-info', user)"
            :class="{activeclass: activeUser == user._id}"
            style="position"
          >

          <!-- @dblclick="changeComponent('users-info', user)" -->
            <td
              class="text-left d-inline-flex" style="float:inline-start"
            >
               <div v-if="Object.keys(user).includes('profile_image') && !['undefined',null].includes(user.profile_image) && user.profile_image" style="position:relative">
                  <div class='user-name-or-image' style="margin-inline-end: 9px;">
                      <img :src="getProxyConvertedURL(user.profile_image)" @error="replaceWithUserIcon($event,user.username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                  </div>
                  <div v-if="user.login_status != undefined && user.login_status.logged_in" :class="{ activestatus: user.login_status.logged_in == true }" style="inset-inline-end :7px;bottom: -10px;"></div>
              </div>
              <div v-else class="user-name-or-image user-name" :style="style(user.username)">{{ user.username.split("")[0] }}
                <div v-if="user.login_status != undefined && user.login_status.logged_in != undefined" :class="{ activestatus: user.login_status.logged_in == true }"></div>
              </div>
              <div style="display: flex;
    align-items: end;">{{ user.username }}</div>
            </td>
            <!-- <td
              :class="{ activestatus: user.status === 'active' }"
              style="color: #cb0707; text-transform: capitalize"
            >
              {{ user.status }}
            </td> -->
            <td class="text-left">
              <span v-if="user.user_type=='Client'">Customer</span>
              <span v-else-if="user.user_type=='SystemUser'">System User</span>
              <span v-else-if="user.user_type=='SystemAdmin'">System Administrator</span>
            </td>
            <td>
              {{getUserGroupNameList(user.group_list)}}
            </td>
            <td :title="getDateAndTimeInConfiguredFormat(user.login_status.session_modified_time)">
              {{ getDateAndTimeInConfiguredFormat(user.login_status.session_modified_time, true) }}
            </td>
            <td class="text-left" style="position:realtive;"><div class="user-email-address">{{ user.email }}</div>
            <!-- </td>
            <td style="position: relative"> -->
              <div class="each-row-actions">  
                <!-- <div class="dropdown"> -->
                  <!-- <div class="nav-item nav-link dropdown-toggle mr-md-2" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <svg
                      width="2em"
                      height="1.5em"
                      viewBox="0 0 16 16"
                      class="bi bi-three-dots more-actions-btn user-actions-icon"
                      fill="#fff"
                      xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                    </svg>
                  </div> -->
                  <!-- <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions"> -->
                    <!-- <a class="dropdown-item p-2 user-actions-icon" @click.stop.prevent="deleteUser(user._id, user.username)" style="color:#fff !important">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 16 16"
                        class="bi bi-trash-fill"
                        style="margin-inline-end: 4px"
                        fill="#fff"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z"/>
                      </svg>
                      Delete
                    </a> -->
                    <!-- <a v-if="user.login_status.logged_in" class="dropdown-item p-2 user-actions-icon" @click.stop.prevent="forceLogout(user._id)" style="color:#fff !important">
                      <svg width="20" height="20" viewBox="0 0 16 16" class="bi bi-box-arrow-right"  style="margin-inline-end: 7px;margin-inline-start:2px;" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"/>
                        <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>
                      </svg>
                      <span style="color:#fff !important">Force logout</span>
                    </a> -->
                  <!-- </div>
                </div> -->
                <svg v-if="user.login_status.logged_in" @click.stop.prevent="forceLogout(user._id)"  width="20" height="20" viewBox="0 0 16 16" class="bi bi-box-arrow-right parent-row-logout user-actions-icon" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <title>{{$t('Force Logout')}}</title>
                  <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"/>
                  <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>
                </svg>
                <svg  @click.stop.prevent="changeComponent('users-info', user)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-pencil parent-row-edit user-actions-icon" viewBox="0 0 16 16">
                  <title>{{$t('Edit')}}</title>
                  <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                </svg>
                <svg @click.stop.prevent="deleteUser(user._id, user.username)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-trash parent-row-delete user-actions-icon" viewBox="0 0 16 16">
                    <title>{{$t('Delete')}}</title>
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                    <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                </svg>
              </div>  
            </td>
          </tr>
        </tbody>
      </table>
    </div>
     <div>
    <pagination
        v-model="page"
        :records="totalUsers"
        :per-page="perPage"
        @paginate="paginate"
        :options="options"
        style="margin-top:10px"
    />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations,mapActions } from "vuex";
import Constants from "../../components.constants.js";
import Utils from "../../components.utils.js";
import Pagination from "vue-pagination-2";
import Multiselect from 'vue-multiselect';
import {NotifierConstants} from "../../components.constants.js";

export default {
  name:'MultiSelect',
  props: ["userId"],
  data() {
    return {
      userGroupList:[],
      page: 1,
      usersList: [],
      isHidden: null,
      userListFromAutocomplete:[],
      searchKey:{username:"All"},
      totalPages: -1,
      totalUsers: -1,
      perPage: -1,
      selectedRowDetails:{},
      activeUser:null,
      options:{chunk:5},
      showUserFilter:false,
      appliedStyle:{},
      searchStatus:{
        type:'active',
        label: 'Active'
      },
      searchUserType:{
        type:'all',
        label:'All'
      },
      fieldTypes:[
      {label:"All",type:"all"},
      {label:"Active",type:"active"},
      {label:"Disabled",type:"disabled"},
      ],
      userTypes:[
        {type:'all',label:'All'},
        {label:"System User",type:"SystemUser"},
        {label:"System Administrator",type:"SystemAdmin"},
        {label:"Customer",type:"Client"},
      ],
      usersListFromServer:[]
    };
  },
  components:{
    pagination: Pagination,
    "Multiselect":Multiselect
  },
  emits: ["changeSelectedComponent"],
  methods: {
    getProxyConvertedImage(image_url){
      return Utils.convertToLoginIPDomainName(image_url);
    },
    style(name){
      let style = {
        'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
        'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
      }
      return style
    },
    getProfileImageOfUser(image){
      let profileImageTag = '<img src='+this.getProxyConvertedURL(image)+' style="width:100%;height:100%;border-radius:6px">'
        return profileImageTag;
    },
    replaceWithUserIcon(e){
        e.target.onerror = null
        e.target.src = Utils.getNoThumbnailImg();
    },
    selectionLabelCallback(option){
        return "Username : " + `${option.username}`
    },
    paginate() {
      // this.page = page;
      this.getUsers(true);
    },
    changeComponent(comp, userInfo={}){
        this.$emit("changeSelectedComponent", comp, userInfo);
    },
    editUser(comp){
      if(this.selectedRowDetails._id != undefined){
        this.changeComponent(comp,this.selectedRowDetails)
      }else{
        alert("Select User to edit");
        return false;
      }
    },
    selectRow(user){
      this.selectedRowDetails = user;
      this.activeUser = user._id;
    },
    optionsOnSelectCallback(option){
      let index = this.userListFromAutocomplete.findIndex(item => item.username == option.username);
      this.searchKey = this.userListFromAutocomplete[index];
      this.getUsers(false);
    },
    optionsOnRemoveCallback(){
      this.searchKey.username = "All";
      this.userListFromAutocomplete = [];
      this.updateUsersList(false)
    },
    getusersOnKeyup(option){
      this.showUserFilter = true
      let payload = {}
      if(typeof(option) != "undefined" && option.trim().length > 0){
        payload.params = {username:option}
        this.getUsersAutoComplitionFromServer(payload).then((data) => {
          this.userListFromAutocomplete = data["users"];
        });
      }else if(option.length==0){
        this.updateUsersList(false);
        this.userListFromAutocomplete = this.usersList;
      }
      let allIndx = -1
      if(this.userListFromAutocomplete){
        allIndx = this.userListFromAutocomplete.findIndex(op=>op._id == "All")
      }
      if(allIndx < 0){
        this.userListFromAutocomplete.unshift({"_id":"All","username":"All"})
      }
    },
    formatedDate(date){
      return Utils.getDateTimeFormat(date);
    },
    getUserGroupNameList(matchedGroupList){
      let userGroupNames = []
      let exten = ""
      if(matchedGroupList.length > 0){
        let mxCount = 0
        for(let eachGroupId of matchedGroupList){
          let mGroupInfo = this.userGroupList.filter(op=>op._id == eachGroupId)
          if(mGroupInfo && mGroupInfo.length > 0){
            if(mxCount >= 2){
              break;
            }
            userGroupNames.push(mGroupInfo[0].group_name);
            mxCount = mxCount + 1;
          }
        }
        if(matchedGroupList.length > 2){
          exten = " + " + (matchedGroupList.length - 2) + " More";
        }
      }else{
        exten = "NONE"
      }
      return userGroupNames.join(", ") + exten;
    },
    deleteUserBtn(){
      if(this.activeUser != undefined){
        this.deleteUser(this.selectedRowDetails._id,this.selectedRowDetails.username)
      }else{
        alert("Select user to delete");
        return false;
      }
    },
    forceLogout(userId) {
      let payload = {};
      payload.params = { query: { user_id: userId } };
      this.forceLogoutUser(payload).then((data) => {
        console.log(`[forceLogout][Userinfo][Force Logout Status->${data}]`);
        this.getUsers();
        this.selectedRowDetails = {}
      });
    },
    deleteUser(userId, username) {
      if (userId == this.getLoggedInUserId()) {
        this.$toast.error("Current logged in user can not be deleted. ");
        return;
      }
      if (
        confirm(
          `Are You sure you want to delete the selected user : "${username}" ?`
        )
      ) {
        this.deleteExistingUser({ userId: userId }).then((data) => {
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            this.$toast.success(data.message);
          } else {
            this.$toast.error(data.message);
          }
        });
        this.getUsers();
        this.selectedRowDetails = {}
      }
    },
    filterUserOnStatus(fieldType){
      this.searchStatus = fieldType;
      this.getUsers(false)
    },
    filterUserType(event){
      this.searchUserType = event
      this.getUsers(false);
    },
    userTypeLabelCallback(option){
      return  "User type : " + option.label
    },
    userStatusLabelCallback(option){
      return "User status : " + option.label
    },
    addUsertoList(user_info){
      let user_exists = this.usersList.filter((user)=>user._id==user_info._id)
      if (user_exists.length ==0){
        this.usersList.push(user_info)
      }else{
        Object.assign(user_exists[0], user_info)
      }
    },
    getUsers(isPageClick = false){
      let payload = {}
        let paramsInfo = {}
        if(isPageClick){
          paramsInfo['page'] = this.page;
        }
        if(this.searchStatus.type != "all"){
          paramsInfo["status"] = this.searchStatus.type;
        }else{
          delete paramsInfo.status
        }
        if(this.searchUserType.type != "all"){
          paramsInfo["user_type"] = this.searchUserType.type;
        }else{
          delete paramsInfo.user_type;
        }
        paramsInfo["login_status"] = true;
        if(typeof(this.searchKey) != "undefined" &&
          this.searchKey.username.trim().length > 0 && this.searchKey.username != "All"){
          paramsInfo["username"] = this.searchKey.username
        }
        payload.params = paramsInfo;
        this.usersListFromServer = []
        this.getAllUsersFromServer(payload).then((data) => {
          this.totalPages = data["page_count"];
          // this.page = data["page"];
          this.totalUsers = data["total_users"];
          this.perPage = data["users_per_page"];if ("users" in data) {
            for (const user of data.users) {
              let temp = user
              // User_list checked added here, to handle the groups not having user_list
              let fGroupList = this.userGroupList.filter(op=>(op.user_list && op.user_list.includes(user._id)))
              let uGIdList = []
              for(let eachGroup of fGroupList){
                 if(!uGIdList.includes(eachGroup._id)){
                   uGIdList.push(eachGroup._id)
                 }
              }
              temp["group_list"] = uGIdList
              this.usersListFromServer.push(temp)
            }
          }
          this.selectedRowDetails = {}
      });
    },
    updateUsersList(isPageClick = false) {
      console.log(isPageClick)
      this.$nextTick(() => {
        this.showUserFilter = false;
        let payload = {}
        let paramsInfo = {}
        paramsInfo['limit'] =  Constants.usersRecordsLimit
        if(this.searchStatus.type != "all"){
          paramsInfo["status"] = this.searchStatus.type;
        }else{
          delete paramsInfo.status
        }
        if(this.searchUserType.type != "all"){
          paramsInfo["user_type"] = this.searchUserType.type;
        }else{
          delete paramsInfo.user_type;
        }
        paramsInfo["login_status"] = true;
        if(typeof(this.searchKey) != "undefined" &&
          this.searchKey.username.trim().length > 0 && this.searchKey.username != "All"){
          paramsInfo["username"] = this.searchKey.username
        }
        payload.params = paramsInfo;
        this.getAllUsersFromServer(payload).then((data) => {
          if ("users" in data) {
            this.usersList = []
            for (const user of data.users) {
              this.addUsertoList(user)
            }
          }
          this.selectedRowDetails = {}
        }); //For users search and pagination send query in payload
      });
    },
    handleUsersNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let user_info = notification.message
        if (notification.message_type == NotifierConstants.userRemovedNotification){
          this.usersList = this.usersList.filter((user)=>user._id!=user_info._id)
          this.usersListFromServer = this.usersListFromServer.filter((user)=>user._id!=user_info._id);
          this.totalUsers -= 1;
        }else{
          let isUserMatchedWithFilters = false;
          if((this.searchUserType && (this.searchUserType.type == user_info.user_type ||this.searchUserType.type == "all")) &&
            (this.searchStatus && (this.searchStatus.type == user_info.status ||this.searchStatus.type == "all")) &&
            (this.searchKey && (this.searchKey.username.toLowerCase() == user_info.username.toLowerCase() || this.searchKey.username == "All"))){
            isUserMatchedWithFilters = true
          }
          if(isUserMatchedWithFilters){
            if(notification.message_type == NotifierConstants.userCreatedNotification){
              this.totalUsers += 1;
            }
            let temp = user_info
            // User_list checked added here, to handle the groups not having user_list
            let fGroupList = this.userGroupList.filter(op=>(op.user_list && op.user_list.includes(user_info._id)))
            let uGIdList = []
            for(let eachGroup of fGroupList){
              if(!uGIdList.includes(eachGroup._id)){
                uGIdList.push(eachGroup._id)
              }
            }
            temp["group_list"] = uGIdList
            this.usersListFromServer.unshift(temp)
          }
        }
      }
    },
    handleUsersSessionNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let session_info = notification.message
        let loggedin_user = this.usersList.filter((user)=>user._id==session_info.user_id)
        if (loggedin_user.length !=0){
          loggedin_user[0]["login_status"] = {logged_in: session_info["logged_in"], session_modified_time: session_info["modified_datetime"], system_ip:session_info["system_ip"]}
        }
      }
    },
    handleUserGroupsNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let groupInfo = notification.message
        if(groupInfo && [NotifierConstants.userGroupCreatedNotification,
          NotifierConstants.userGroupModifiedNotification].includes(notification.message_type)){
          this.reloadUserGroupDetails();
          for(let uId of groupInfo.user_list){
            let uindx = this.usersListFromServer.findIndex(op=>op._id==uId && !op.group_list.includes(groupInfo._id))
            let uEntry = this.usersListFromServer.filter(op=>op._id==uId && !op.group_list.includes(groupInfo._id))
            if(uEntry && uEntry.length > 0){
              let currentGIList = uEntry[0].group_list
              currentGIList.push(groupInfo._id)
              this.$set(this.usersListFromServer[uindx], "group_list", currentGIList)
            }
          }
          if(notification.message_type == NotifierConstants.userGroupModifiedNotification && 'removed_user_list' in groupInfo){
            for(let uId of groupInfo.removed_user_list){
              let uindx = this.usersListFromServer.findIndex(op=>op._id==uId && op.group_list.includes(groupInfo._id))
              let uEntry = this.usersListFromServer.filter(op=>op._id==uId && op.group_list.includes(groupInfo._id))
              if(uEntry && uEntry.length > 0){
                let currentGIList = uEntry[0].group_list
                currentGIList = currentGIList.filter(o=>o!=groupInfo._id)
                this.$set(this.usersListFromServer[uindx], "group_list", currentGIList)
              }
            }
          }
        }else if(NotifierConstants.userGroupRemovedNotification == notification.message_type){
          for(let eachUser of this.usersListFromServer){
            if(eachUser.group_list.includes(groupInfo._id)){
              let updatedUserList = eachUser.group_list.filter(op=>op!=groupInfo._id)
              this.$set(this.usersListFromServer[this.usersListFromServer.findIndex(op=>op._id==eachUser._id)], "group_list", updatedUserList)
            }
          }
        }

    },
    reloadUserGroupDetails(){
      if(Object.keys(this.getStartUpDataFromInCache()).includes("user_groups")){
        this.userGroupList = this.getStartUpDataFromInCache()["user_groups"];
      }
    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({
            eventname:[NotifierConstants.userCreatedNotification, NotifierConstants.userModifiedNotification, NotifierConstants.userRemovedNotification],
            callback:this.handleUsersNotification,
            parent:"ShowUsers"})
      this.addWSEventListener({
            eventname:[NotifierConstants.userLoggedInNotification, NotifierConstants.userLoggedOutNotification],
            callback:this.handleUsersSessionNotification,
            parent:"ShowUsers"})
      this.addWSEventListener({eventname:[NotifierConstants.userGroupCreatedNotification, NotifierConstants.userGroupModifiedNotification,NotifierConstants.userGroupRemovedNotification],
            callback:this.handleUserGroupsNotification,parent:"ShowUsers"})
    },
    unRegisterforWebsocketNotifications(){
      this.removeWSEventListener({
            eventname:[NotifierConstants.userCreatedNotification, NotifierConstants.userModifiedNotification, NotifierConstants.userRemovedNotification],
            callback:this.handleUsersNotification,
            parent:"ShowUsers"})
      this.removeWSEventListener({
            eventname:[NotifierConstants.userLoggedInNotification, NotifierConstants.userLoggedOutNotification],
            callback:this.handleUsersSessionNotification,
            parent:"ShowUsers"})
      this.addWSEventListener({eventname:[NotifierConstants.userGroupCreatedNotification, NotifierConstants.userGroupModifiedNotification,NotifierConstants.userGroupRemovedNotification],
            callback:this.handleUserGroupsNotification,parent:"ShowUsers"})
    },
    ...mapActions("users", ["getAllUsersFromServer", "deleteExistingUser",
    "getUsersAutoComplitionFromServer","forceLogoutUser"]),
    ...mapGetters("users", ["getUsersList", "getLoggedInUserId"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapActions("userGroups", ["getUserGroupInfoFromServer"]),
  },
  created() {
    this.reloadUserGroupDetails()
    this.registerforWebsocketNotifications()
    this.getUsers(false)
  },
  beforeDestroy(){
    this.unRegisterforWebsocketNotifications()
  }
};
</script>


<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;

  .activeclass {
    color: $active-blue !important;
  }
  // .table-scroll {
  //   /*width:100%; */
  //   border: none !important;
  //   /* Decoration */
  //   border-spacing: 0;
  //   width: 100%;
  //   thead {
  //     color: $dull-text-color !important;
  //     position: relative;
  //     th{
  //       position: sticky;
  //       top: 0;
  //       z-index:9;
  //       text-align: start;
  //       background: $primary-background;
  //       padding: 5px;
  //     }
  //   }
  //   tbody {
  //     width: 100%;
  //     overflow: auto;
  //     font-weight: 500;
  //     tr{
  //       height: 45px;
  //       td{
  //         text-align: start;
  //         padding: 5px;;
  //       }
  //     }
  //   }
  // }

  // .table{
  //   th{
  //     border-top:none !important;
  //   }
  //   td{
  //     border-top:none !important;
  //   }
  // }



.table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        margin: 0px 15px;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th {
            position: sticky;
            top: 0;
            background: $primary-background;
            z-index: 9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr {
            height: 45px;
            }
            tr:hover{
                background: $bg-color-on-hover;
            }
        }
    }

    .table {
        th {
            border-top: none !important;
            padding:0 10px !important;
        }
        td {
            border-top: none !important;
            padding:0 1rem!important;
        }
    }

    th {
        border-top: none !important;
        padding:0 10px !important;
    }

    .table-cell-styles{
        td{
            padding:0 10px !important;
        }
    }

    .table-with-border {
        thead {
            border-bottom: $border-color;
        }
        tr {
            border-bottom: $border-color;
        }
    }

.small-col {
  flex-basis: 10%;
}

.comm-user-row:hover {
  :not(.user-name), :not(.comm-user-row:last-child), :not(.user-actions-icon){
    color: $active-blue;
    background: $bg-color-on-hover;
  }
  td:first-child {
    :not(.user-name){
    text-decoration: underline;
    }
  }
}

.user-email-address{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 278px;
}

.height-set-for-component {
  height: calc(100% - 95px);
}

table .more-actions-btn {
  visibility: hidden;
}
table tr:hover .more-actions-btn {
  visibility: visible;
}

.search-bar-comm-style {
  margin-top: 5px;
}

.each-row-actions{
  width: 200px;
  position: absolute;
  display: inline-flex;
  inset-inline-end: 0px;
  top: 0px;
  justify-content: end;
}

.show-delete-icon:hover{
    position: relative;
    .parent-row-delete,  .parent-row-edit, .parent-row-logout{
        visibility: visible;
    }
}

.parent-row-delete, .parent-row-edit, .parent-row-logout{
    margin-inline-start: 3px;
    // position: absolute;
    // inset-inline-end :0px;
    z-index: 1;
    background: #525252 !important;
    border: 1px solid #262626 !important; 
    width: 55px;
    height: 44px;
    padding: 12px;
    top: 0px;
    border-radius: 4px;
    visibility: hidden;
    color: #fff !important;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}


.activestatus {
  border: 2px solid $border-color-only;
  height: 13px;
  width: 13px;
  inset-inline-end: -4px;
  position: absolute;
  bottom: -3px;
  border-radius: 10px;
  background: $active-green-icon-color !important;
}

.primary-btn-style{
    width: 100%;
    text-align: end;
    button{
        height: 38px;
        width: 70px;
        font-size:14px;
    }
    .text-light:hover{
      text-decoration: underline;
    }
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
    top:4px !important;
}

.user-name{
    margin-inline-end: 10px;
    position: relative;
    bottom: 7px;
}
::v-deep {
   .multiselect__content-wrapper{
    display:none;
  }
  .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background !important;
        border: $border-color !important;
    }
    .multiselect__option--highlight {
       background: $bg-color-on-hover !important;
    }
    .multiselect__content {
       background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__input:focus{
      outline:none;
      box-shadow: none;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color:$text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color  !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: 12px !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect__placeholder {
      padding-top: 0px;
     }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      min-width: 28%;
      width: auto;
      min-height: 38px;
      height: 38px;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: relative;
        display: block;
        background: $text-color;
        width: 100%;
        max-height: 240px;
        overflow: auto;
        border: 1px solid $text-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background!important;
        height: $input-field-height;
        min-height: 38px;
    }
    .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
          color: $secondary-text-color !important;
          margin-bottom: 0px !important;
          font-size: 12px;
          margin-inline-end: 7px;
          margin-top: 1px;
          float: inline-end;
          margin-inline-start: 5px;
          position: relative;
          top:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }
}

</style>